module.exports = __webpack_public_path__ + "static/img/iconmonstr-magnifier-7.1554636b.svg";